(function (root, factory) {
  const api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.VendeyPayment = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  function redondearMoneda(valor) {
    return Math.round((valor + Number.EPSILON) * 100) / 100;
  }

  function normalizarImporte(valor) {
    if (typeof valor === "number") {
      return Number.isFinite(valor) ? redondearMoneda(valor) : NaN;
    }

    let texto = String(valor == null ? "" : valor)
      .trim()
      .replace(/vuelto/gi, "")
      .replace(/s\//gi, "")
      .replace(/\s/g, "");

    if (texto.includes(",") && !texto.includes(".")) {
      texto = texto.replace(",", ".");
    } else {
      texto = texto.replace(/,/g, "");
    }

    const numero = Number(texto);
    return Number.isFinite(numero) ? redondearMoneda(numero) : NaN;
  }

  function normalizarPorcentaje(valor) {
    const numero = Number.parseFloat(String(valor == null ? "" : valor).trim().replace(",", "."));
    if (!Number.isFinite(numero)) return 0;
    return Math.min(100, Math.max(0, numero));
  }

  function esPagoYape(texto) {
    return /(^|\s|[-|])yape($|\s|[-|])/.test(String(texto || "").trim().toLowerCase());
  }

  function calcularComisionYape(totalBase, porcentaje) {
    const base = normalizarImporte(totalBase);
    const tasa = normalizarPorcentaje(porcentaje);
    if (!Number.isFinite(base) || base <= 0 || tasa <= 0) return 0;
    return redondearMoneda(base * tasa / 100);
  }

  function crearResumenPago(datos) {
    const totalVenta = normalizarImporte(datos && datos.totalVenta);
    const montoPagado = normalizarImporte(datos && datos.montoPagado);
    const vueltoInformado = normalizarImporte(datos && datos.vuelto);

    if (!Number.isFinite(totalVenta) || totalVenta <= 0) {
      throw new Error("El total de la venta no es válido.");
    }
    if (!Number.isFinite(montoPagado) || montoPagado < totalVenta) {
      throw new Error("El monto pagado debe ser igual o mayor al total de la venta.");
    }

    const vueltoCalculado = redondearMoneda(montoPagado - totalVenta);
    const vuelto = Number.isFinite(vueltoInformado) ? vueltoInformado : vueltoCalculado;

    if (Math.abs(vuelto - vueltoCalculado) > 0.01) {
      throw new Error("El vuelto registrado no coincide con el monto pagado.");
    }

    return {
      totalVenta,
      montoPagado,
      vuelto: vueltoCalculado,
      montoAplicado: redondearMoneda(montoPagado - vueltoCalculado),
      montoPendiente: 0
    };
  }

  function crearCamposEmision(resumen) {
    if (!resumen || !Number.isFinite(resumen.montoPagado) || !Number.isFinite(resumen.vuelto)) {
      throw new Error("No existe un pago válido para emitir.");
    }

    return {
      cabecera: {
        NMONTOPAGADO: resumen.montoPagado,
        NMONTOPENDIENTE: resumen.montoPendiente
      },
      pago: {
        NPAGOTOTAL: resumen.montoPagado,
        NMONTOVENTA: resumen.totalVenta,
        NVUELTO: resumen.vuelto
      }
    };
  }

  function vibrarErrorPago() {
    if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") {
      return false;
    }
    return navigator.vibrate([180, 90, 180]);
  }

  return {
    normalizarImporte,
    normalizarPorcentaje,
    esPagoYape,
    calcularComisionYape,
    crearResumenPago,
    crearCamposEmision,
    vibrarErrorPago
  };
});
